var tmplList = require('./list.handlebars')
  , tmplNone = require('./none.handlebars')
  , timeformat = require('mods/timeformat')
  , getImageSource = require('widgets/getImageSource')

function Newswaterfall () {
  this.init()
}

Newswaterfall.prototype = {
  init: function() {
    this.page = 1;
    this.pageSize = 10;
    this.getList();
  },
  getList: function(page) {

      var that = this;
      page = page || 1;
      $.ajax({
        type: 'Get',
        url: '/api/newswaterfall',
        dataType: 'jsonp',
        data: {
          game_code: ued.gameCode,
          page_no: page,
          page_size: that.pageSize
        }
      })
      .done(function(res){
        $('.loading').hide();
        that.state = 'READY';
        if (res.totalCount > 0) {
            that.renderList(res.data);
            if (page == 1) {
                that.totalPage = Math.ceil(res.totalCount / that.pageSize);
                if (that.totalPage > 1) {
                    that.bindLoadListEvent();
                }
            }
        } else {
            $('#ptlist_news').parents('#pn_news').html(tmplNone());
            that.totalPage = 0;
        }
      })
  },
  bindLoadListEvent: function() {
    var that = this;
    $(window).on('scroll.loadList', function() {
      var  top  =  document.documentElement.scrollTop  +  document.body.scrollTop;
      var documentHeight = $(document).height();
      if (documentHeight - top - $(window).height() <= 200 && that.state === 'READY' && window.currentIsNews) {
        that.state = 'LOADING';
        $('.loading').show();
        that.page += 1;
        that.getList(that.page);
        if (that.page == that.totalPage) {
            $(window).off('scroll.loadList');
        }
      }
    });
  },
  renderList: function(res) {
    var that = this;
    var data = [];
    $.each(res, function(i, val) {
      if (val.image.length == 0) {
        val.hasImage = false;
      } else {
        val.image = getImageSource(val.image, '240x');
        val.hasImage = true;
      }
      val.pub_time = timeformat.sec2date(val.pub_time);
      data.push(val);
    });
    $('#ptlist_news').append(tmplList(data));
  }
};

module.exports = Newswaterfall